import React, { useState } from 'react';
import confetti from 'canvas-confetti';
interface SignupModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function SignupModal({
  isOpen,
  onClose
}: SignupModalProps) {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim() === '') return;
    // Here you would typically send the email to your backend
    setIsSubmitted(true);
    // Trigger confetti
    confetti({
      particleCount: 100,
      spread: 70,
      origin: {
        y: 0.6
      },
      colors: ['#10b981', '#34d399', '#a7f3d0']
    });
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center z-50 p-4" data-id="element-247">
      <div className="bg-white dark:bg-black rounded-3xl max-w-lg w-full p-8 relative border border-black/5 dark:border-white/10" onClick={e => e.stopPropagation()} data-id="element-248">
        <button onClick={onClose} className="absolute top-4 right-4 text-black/40 dark:text-white/40 hover:text-black dark:hover:text-white transition-colors" data-id="element-249">
          ✕
        </button>
        {!isSubmitted ? <div data-id="element-250">
            <h2 className="text-2xl md:text-3xl font-light mb-4" data-id="element-251">
              join our{' '}
              <span className="text-mint-600 dark:text-mint-400" data-id="element-252">waitlist</span>
            </h2>
            <p className="text-black/60 dark:text-white/60 mb-8" data-id="element-253">
              Be among the first to experience caltalk and receive exclusive
              early access benefits.
            </p>
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-254">
              <div data-id="element-255">
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your email" className="w-full px-4 py-3 bg-black/5 dark:bg-white/5 rounded-lg border border-transparent focus:border-mint-500 dark:focus:border-mint-400 focus:outline-none transition-colors" required data-id="element-256" />
              </div>
              <button type="submit" className="w-full px-6 py-3 bg-mint-500/10 dark:bg-mint-400/10 text-mint-600 dark:text-mint-400 font-light rounded-full hover:bg-mint-500/20 dark:hover:bg-mint-400/20 transition-all group relative overflow-hidden" data-id="element-257">
                <span className="relative z-10" data-id="element-258">join waitlist</span>
                <span className="absolute inset-0 bg-gradient-to-r from-mint-400/20 to-mint-500/20 blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-259" />
              </button>
            </form>
          </div> : <div className="text-center py-6" data-id="element-260">
            <div className="w-16 h-16 rounded-full bg-mint-500/10 dark:bg-mint-400/10 flex items-center justify-center mx-auto mb-6" data-id="element-261">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-262">
                <path d="M20 6L9 17L4 12" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-263" />
              </svg>
            </div>
            <h2 className="text-2xl font-light mb-4" data-id="element-264">thank you for joining</h2>
            <p className="text-black/60 dark:text-white/60 mb-8" data-id="element-265">
              We'll notify you when caltalk is ready for early access. Stay
              tuned for updates.
            </p>
            <button onClick={onClose} className="px-6 py-3 bg-mint-500/10 dark:bg-mint-400/10 text-mint-600 dark:text-mint-400 font-light rounded-full hover:bg-mint-500/20 dark:hover:bg-mint-400/20 transition-all" data-id="element-266">
              close
            </button>
          </div>}
      </div>
    </div>;
}